import { render } from "./CombineOrders.vue?vue&type=template&id=6cad8ba8&scoped=true"
import script from "./CombineOrders.vue?vue&type=script&lang=js"
export * from "./CombineOrders.vue?vue&type=script&lang=js"

import "./CombineOrders.vue?vue&type=style&index=0&id=6cad8ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cad8ba8"]])

export default __exports__